<template>
  <div>
    <secondHeader />
    <div class="main">
      <sidebar />
      <div class="content">
    <div class="content-title">
      <h2>
        肉球コメント| グリッチコメント
      </h2>
      <p>プレミアムコンテンツ(有料)のフォントをカスタマイズできます。プレビューは肉球ですがグリッチにも使えます。</p>
    </div>
    <div class="contents-block">
    <div class="line__left" v-bind:class="fontStyle">
        <div class="line__left-text">
            <div class="text">Hello🐟</div>
        </div>
        <div class="line__left-text">
            <div class="text">いい天気ですね</div>
        </div>
    </div>
    <div class="set">
      <h3>フォント選択</h3>
      <select class="select " v-model="fontstyle">
        <optgroup label="--ゴシック--">
          <option value="font1">Zen角ゴシックAntique</option>
          <option value="font4">DotGothic16</option>
          <option value="font7">M PLUS Rounded 1c</option>
          <option value="font6">キウイ丸</option>
        </optgroup>
        <optgroup label="--ポップ--">
          <option value="font2">はちまるポップ</option>
          <option value="font8">ロックンロールOne</option>
        </optgroup>
        <optgroup label="--明朝--">
          <option value="font12">さわらび明朝</option>
          <option value="font13">しっぽり明朝</option>
        </optgroup>
        <optgroup label="--デザイン--">
          <option value="font3">Stick</option>
          <option value="font5">解星デコール</option>
          <option value="font9">佑字【舞】</option>
          <option value="font10">油性マジック</option>
        </optgroup>
        <optgroup label="--Chinese--">
          <option value="font14">Noto Serif</option>
        </optgroup>
        <optgroup label="--English--">
          <option value="font15">Josefin Sans</option>
        </optgroup>
      </select>

      <h3>コピペ用CSS</h3>
      <h4>YouTubeLIVEコメント欄のカスタムCSS</h4>
      <div class="radio-main">
        <textarea id="target" readonly class="m-form-text" v-model="resultCSS" />
        <button @click="copy" class="copy-btn">コピー</button>
      </div>
      <h4>Twitchコメント欄のカスタムCSS</h4>
      <div class="radio-main">
        <textarea id="target" readonly class="m-form-text" v-model="twresultCSS" />
        <button @click="copy2" class="copy-btn">コピー</button>
      </div>
    </div>
  </div>
</div>
</div>
  </div>
</template>
<script>
import secondHeader from "../../components/secondHeader.vue";
import sidebar from "../../components/sidebar.vue"
export default {
  name: "app",
    components: {
    secondHeader,
    sidebar,
  },

  data() {
    return {
        fontstyle:'font1',

        importcss:'yt-live-chat-text-message-renderer #content{',
        fontcss:'font-family: "Zen Kaku Gothic Antique", sans-serif;}',
        twimportcss:'.chat-line__no-background{\n',
    };
  },
  methods: {
    copy () {
      if(navigator.clipboard){
        navigator.clipboard.writeText(this.importcss + this.fontcss)
        console.log('コピー完了')
        return true
      } else {
        return false
      }
    },
    copy2 () {
      if(navigator.clipboard){
        navigator.clipboard.writeText(this.twimportcss + this.fontcss)
        console.log('コピー完了')
        return true
      } else {
        return false
      }
    },
    setFontCss: function(){
        switch(this.fontstyle){
            case 'font1':
                this.fontcss = 'font-family: "Zen Kaku Gothic Antique", sans-serif;}'
                break;
            case 'font2':
                this.fontcss = 'font-family: "Hachi Maru Pop", cursive;}'
                break;
            case 'font3':
                this.fontcss = 'font-family: "Stick", sans-serif;}'
                break;
            case 'font4':
                this.fontcss = 'font-family: "DotGothic16", sans-serif;}'
                break;
            case 'font5':
                this.fontcss = 'font-family: "Kaisei Decol", serif;}'
                break;
            case 'font6':
                this.fontcss = 'font-family: "Kiwi Maru", serif;}'
                break;
            case 'font7':
                this.fontcss = 'font-family: "M PLUS Rounded 1c", sans-serif;}'
                break;
            case 'font8':
                this.fontcss = 'font-family: "RocknRoll One", sans-serif;}'
                break;
            case 'font9':
                this.fontcss = 'font-family: "Yuji Mai", serif;}'
                break;
            case 'font10':
                this.fontcss = 'font-family: "Yusei Magic", sans-serif;}'
                break;
            case 'font12':
                this.fontcss = 'font-family: "Sawarabi Mincho", serif;";}'
                break;
            case 'font13':
                this.fontcss = 'font-family: "Shippori Mincho", serif;}'
                break;
            case 'font14':
                this.fontcss = 'font-family: "Noto Serif SC", serif;}'
                break;
            case 'font15':
                this.fontcss = 'font-family: "Josefin Sans", sans-serif;}'
                break;
        }
    }
  },
  watch:{
    fontstyle:function(){
        this.setFontCss()
    },
  },
  computed: {
    resultCSS(){
        return this.importcss + this.fontcss;
    },
    twresultCSS(){
        return this.twimportcss + this.fontcss;
    },
    fontStyle: function() {
      if (this.fontstyle === 'font1') {
        return 'font1';
      }
      else if (this.fontstyle === 'font2') {
        return 'font2';
      }
      else if (this.fontstyle === 'font3') {
        return 'font3';
      }
      else if (this.fontstyle === 'font4') {
        return 'font4';
      }
      else if (this.fontstyle === 'font5') {
        return 'font5';
      }
      else if (this.fontstyle === 'font6') {
        return 'font6';
      }
      else if (this.fontstyle === 'font7') {
        return 'font7';
      }
      else if (this.fontstyle === 'font8') {
        return 'font8';
      }
      else if (this.fontstyle === 'font9') {
        return 'font9';
      }
      else if (this.fontstyle === 'font10') {
        return 'font10';
      }
      else if (this.fontstyle === 'font12') {
        return 'font12';
      }
      else if (this.fontstyle === 'font13') {
        return 'font13';
      }
      else if (this.fontstyle === 'font14') {
        return 'font14';
      }
      else if (this.fontstyle === 'font15') {
        return 'font15';
      }
      else {
        return '';
      }
    },
  },
};
</script>
<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Hachi+Maru+Pop&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Stick&display=swap');
@import url('https://fonts.googleapis.com/css2?family=M+PLUS+1p:wght@500&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Zen+Kaku+Gothic+Antique&display=swap');

@import url('https://fonts.googleapis.com/css2?family=DotGothic16&family=Kaisei+Decol:wght@500&family=Kiwi+Maru:wght@500&family=M+PLUS+Rounded+1c:wght@500&family=RocknRoll+One&family=Sawarabi+Mincho&family=Shippori+Mincho:wght@500&family=Yuji+Mai&family=Yusei+Magic&display=swap');

@import url('https://fonts.googleapis.com/css2?family=Josefin+Sans&family=Noto+Serif+SC&display=swap');

p {
  margin: 0;
  padding: 0;
  font-size: 14px;
}

.main {
  min-height: 100vh;
  display: flex;
  flex-direction: row;
  flex-grow: 1;
  margin: 0 auto;
  background: linear-gradient(-225deg, #acb6e5 0%, #fff 25%,#fff 75%, #FFBAC3 100%);
}

.content {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  padding: 60px 0 60px 1.82%;
}

.content-title{
  text-align: center;
  padding-bottom: 12px;
  margin-top:48px;
  margin-bottom: 48px;
}

h2{
  position: relative;
  display: inline-block;
  text-align: center;
  letter-spacing: 3px;
  text-shadow: 2px 2px 6px rgb(210 210 210 / 80%);
}

h3{
  font-size: 14px;
  margin-top: 24px;
}

h4{
  font-size: 12px;
  margin-top: 24px;
  margin-bottom: 0;
}


.contents-block{

	-webkit-flex-wrap: nowrap;
	flex-wrap: nowrap;
	-webkit-justify-content: space-around;
	justify-content: space-around;
	-webkit-align-items: flex-start;
	align-items: flex-start;
  margin: 24px auto;

}

@media screen and (max-width: 767px) {
  .contents-block{
    display: block;
    margin: 0 auto;
  }

  .set{
    margin-top:24px;
  }
}
.set{
  padding: 8px 12px 24px 12px;

  border-radius: 10px;
  margin-left:12px;
}

/* コメントエリア */
.preview{
    padding: 2px 12px;
}

.line__left-text{
    margin: 6px auto !important;
    overflow: hidden !important;
    font-weight: bold !important;
    font-size: 16px !important;
    background-color: rgba(0, 0, 0, 0) !important;
    line-height: 1.8;
    letter-spacing: 0.1em;
    padding-left: 32px;
    padding-top:12px
}

.text {
    display: inline-block !important;
    width: auto !important;
    color: #0C134F;
  margin-top:5px;
  margin-left: 28px;
  padding: 2px 24px 4px 12px;
  position: relative;
  background: #DDE6ED;
  border: 2px solid #0C134F;
  border-radius: 0 24px 24px 24px;
}

/* 吹き出し */
.text:before {
    content: "";
    display: inline-block;
    width: 2px;

    background-color: #0C134F;
    position: absolute;
    top: 12px;
    left: -28px;
    animation: line-anime 0.5s forwards linear;
    animation-delay: 0.3s;
}

@keyframes line-anime {
    0% {
        height: 0px;
    }

    100% {
        height: 70%;
    }
}

.text:after {
    content: '';
    position: absolute;
    left: -38px;
    top: -12px;
    width: 1.3em;
    height: 1.3em;
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;

    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' version='1.1' viewBox='0 0 256 256'%3E%3Ccircle fill='%230C134F' cx='92.00' cy='66.99' r='24.93'/%3E%3Ccircle fill='%230C134F' cx='163.00' cy='66.99' r='24.92'/%3E%3Ccircle fill='%230C134F' cx='48.00' cy='114.00' r='24.93'/%3E%3Ccircle fill='%230C134F' cx='208.00' cy='113.99' r='24.93'/%3E%3Cpath fill='%230C134F' d=' M 166.81 117.19 C 186.41 134.74 218.94 179.61 179.06 197.47 C 148.94 210.95 104.95 210.58 74.93 195.56 C 54.77 185.47 58.19 163.68 67.19 147.19 C 78.81 125.89 97.53 106.71 120.69 98.42 C 136.23 92.86 155.24 106.82 166.81 117.19 Z'%0A/%3E%3C/svg%3E%0A");

    animation: icon-anime-y 1.5s ease-in-out forwards;
    animation-delay: 0.3s;
}

@keyframes icon-anime-y {
    to {
        transform: rotateY(360deg);
    }
}


.select-gradation{
  text-align: center;
  background-color: aliceblue;
  width: -moz-fit-content;
  width: fit-content;
  margin: 0 auto;
  padding: 24px 24px 12px 24px;
  line-height: 1;
  border-radius: 10px;
  margin-right: 12px;
}

.select-font{
    font-size: 24px;
  text-align: center;
  background-color: aliceblue;
  width: -moz-fit-content;
  width: fit-content;
  padding: 12px;
  line-height: 1;
  border-radius: 10px;
  margin-right: 12px;
}

.date-off{
  display:none;
}

.font1{
    font-family: 'Zen Kaku Gothic Antique', sans-serif;
}
.font2{
    font-family: 'Hachi Maru Pop', cursive;
}
.font3{
    font-family: 'Stick', sans-serif;
}
.font4{
    font-family: "DotGothic16", sans-serif;
}
.font5{
    font-family: "Kaisei Decol", serif;
}
.font6{
    font-family: "Kiwi Maru", serif;
}
.font7{
    font-family: "M PLUS Rounded 1c", sans-serif;
}
.font8{
    font-family: "RocknRoll One", sans-serif;
}
.font9{
    font-family: "Yuji Mai", serif;
}
.font10{
    font-family: "Yusei Magic", sans-serif;
}
.font12{
    font-family: 'Sawarabi Mincho', serif;
}
.font13{
    font-family: 'Shippori Mincho', serif;
}
.font14{
    font-family: 'Noto Serif SC', serif;
}
.font15{
    font-family: 'Josefin Sans', sans-serif;
}
.radio-main{
  display: -webkit-flex;
  display: flex;
}
.m-form-text{
    width: 80%;
  height: 42px;
  padding: 0 16px;
  border-radius: 4px;
  border: none;
  box-shadow: 0 0 0 1px #ccc inset;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
}

.select{
  padding: 0 16px;
  border-radius: 4px;
  border: none;
  box-shadow: 0 0 0 1px #ccc inset;
}

.copy-btn{
  background-color: #fff;
  border-radius: 4px;
  border: none;
  box-shadow: 0 0 0 1px #ccc inset;
  font-size:0.5rem;
  width: 20%;
}

.copy-btn:active{
  -webkit-transform: translateY(4px);
  transform: translateY(4px);
  border-bottom: none;
}

.line__left{
  display: block;
  white-space: nowrap;

}
</style>